import { Injectable } from '@angular/core';
import { MsalService } from '@azure/msal-angular';
import {
  AuthenticationResult,
  InteractionType,
  PublicClientApplication,
} from '@azure/msal-browser';

import { OAuthSettings } from '../../../oauth'
import { User } from '../models/user';

import { Client } from '@microsoft/microsoft-graph-client';
import { AuthCodeMSALBrowserAuthenticationProvider } from '@microsoft/microsoft-graph-client/authProviders/authCodeMsalBrowser';
import * as MicrosoftGraph from '@microsoft/microsoft-graph-types';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { map, catchError, switchMap } from 'rxjs/operators';
import { Observable, of, Subject, throwError } from 'rxjs';
import { AuthService } from './auth.service';
import {
  MICROSOFT_RECONNECT_REQUIRED,
  MicrosoftSessionService,
} from './microsoft-session.service';
import { Router } from '@angular/router';

const GRAPH_ENDPOINT = 'https://graph.microsoft.com/v1.0/me';
const GRAPH_ENDPOINT_PIC = 'https://graph.microsoft.com/v1.0/me/photo/$value';

@Injectable({
  providedIn: 'root',
})
export class OfficeoauthService {
  public authenticated: boolean;
  public user?: User;
  public graphClient?: Client;
  public rootPath: string = 'prospect';

  isUserLoggedIn: Subject<boolean> = new Subject<boolean>();

  constructor(
    private http: HttpClient,
    private msalService: MsalService,
    private authService: AuthService,
    private microsoftSession: MicrosoftSessionService,
    private router: Router
  ) {
    /* this.initializeGraphClient();
     const accounts = this.msalService.instance.getAllAccounts();
     this.authenticated = accounts.length > 0;
     if (this.authenticated) {
       this.msalService.instance.setActiveAccount(accounts[0]);

       var that = this;
       this.getUser().then((user) => {that.user = user;});
    
       
     }*/
  }

  /**
   * Graph client for the features that genuinely need Microsoft: Outlook
   * calendar, appointments, SharePoint explorer.
   *
   * Token acquisition is delegated to MicrosoftSessionService, which tries the
   * cached account then a hidden-iframe SSO recovery and **never navigates**.
   * This used to fire `acquireTokenRedirect` on its own, which ejected the user
   * to Microsoft (and, with no live Entra session, dumped them on /login) just
   * for opening an appointments screen. Now the Graph call simply fails, the
   * page stays put, and the header offers a one-click reconnect.
   */
  async initializeGraphClient() {
    this.graphClient = Client.init({
      authProvider: async done => {
        const result = await this.microsoftSession.acquireToken(['user.read'], {
          essential: true,
        });
        if (!result) {
          done(new Error(MICROSOFT_RECONNECT_REQUIRED), null);
          return;
        }
        done(null, result.accessToken);
      },
    });
  }

  getGraphClient(): Client {
    return this.graphClient;
  }

  getToken(): string {
    return localStorage.getItem(
      'msal.token.keys.6f4a7291-9359-4d8e-a0b8-bab7d671adfd'
    );
  }

  getUserDetails(): any {
    const accountInfo = this.msalService.instance.getAllAccounts()[0]; // Obtient le premier compte, ajustez selon vos besoins

    if (accountInfo) {
      const userEmail = accountInfo.username; // `username` contient généralement l'adresse e-mail
      return userEmail;
    }
    return null;
  }

  // Prompt the user to sign in and
  // grant consent to the requested permission scopes
  /* async signIn(): Promise<void> {
     const result = await this.msalService
       .loginPopup(OAuthSettings)
       .toPromise()
       .catch((reason) => {
         this.alertsService.addError('Login failed',
           JSON.stringify(reason, null, 2));
       });
 
     if (result) {
 
       this.msalService.instance.setActiveAccount(result.account);
       this.authenticated = true;
       this.user = await this.getUser();
 
       
     }
   }
 */
  ServerUrl = environment.serverUrl;
  error: any;

  get isUserLoggedInValue() {
    return this.isUserLoggedIn.asObservable();
  }

  // Newgraph fonction pour récupérer le profil de l'utilisateur et sa photo

  getUserProfile(): Observable<any> {
    return this.microsoftSession
      .acquireToken$(['user.read'], { essential: false })
      .pipe(
        switchMap(tokenResponse => {
          const headers = {
            Authorization: `Bearer ${tokenResponse.accessToken}`,
          };
          return this.http.get<any>(GRAPH_ENDPOINT, { headers });
        }),
        catchError(error => {
          console.error('Erreur lors de la récupération du profil:', error);
          return throwError(error);
        })
      );
  }

  getUserProfilePic(): Observable<Blob> {
    // A missing Microsoft account must not kill the app session:
    // the caller falls back to the default avatar.
    return this.microsoftSession
      .acquireToken$(['user.read'], { essential: false })
      .pipe(
        switchMap(tokenResponse => {
          const headers = {
            Authorization: `Bearer ${tokenResponse.accessToken}`,
          };
          return this.http.get(GRAPH_ENDPOINT_PIC, {
            headers,
            responseType: 'blob',
          });
        }),
        catchError(error => {
          //console.error('Erreur lors de la récupération de la photo de profil:', error);
          //return throwError(error);
          return of(null);
        })
      );
  }

  private readonly scopes: string[] = ['user.read'];

  errorData: {};
  private handleError(error: HttpErrorResponse) {
    if (error.error instanceof ErrorEvent) {
      // A client-side or network error occurred. Handle it accordingly.
      console.error('An error occurred:', error.error.message);
    } else {
      // The backend returned an unsuccessful response code.
      // The response body may contain clues as to what went wrong.
      console.error(
        `Backend returned code ${error.status}, ` + `body was: ${error.error}`
      );
    }

    // return an observable with a user-facing error message
    this.errorData = {
      errorTitle: 'Oops! Request failed',
      errorDesc: 'Something bad happened. Please try again later.',
    };
    return throwError(this.errorData);
  }

  async clearCache(): Promise<void> {
    const accounts = await this.msalService.instance.getAllAccounts();
    accounts.forEach(async account => {
      await this.msalService.logout({ account });
    });
  }

  async signOut(): Promise<void> {
    try {
      const account = this.msalService.instance.getActiveAccount();
      if (account) {
        // MSAL logout
        this.msalService.instance.logout({ account: account });

        /* this.msalService.getAccount().logout();
         this.msalService.clearCache();
         */

        // Reset application state
        this.user = undefined;
        this.authenticated = false;

        // Log out from any other service or application state
        this.authService.logout();

        // Close the tab
        window.close();

        // Redirect to login
        // this.router.navigate(['/login']);
      }
    } catch (error) {
      console.error('Error signing out:', error);
    }
  }

  private async getUser(): Promise<User | undefined> {
    if (!this.isUserLoggedIn) return undefined;

    // Create an authentication provider for the current user
    const authProvider = new AuthCodeMSALBrowserAuthenticationProvider(
      this.msalService.instance as PublicClientApplication,
      {
        account: this.msalService.instance.getActiveAccount()!,
        scopes: [...OAuthSettings.scopes, 'Files.Read', 'Files.ReadWrite'],
        interactionType: InteractionType.Redirect,
      }
    );

    // Initialize the Graph client
    this.graphClient = Client.initWithMiddleware({
      authProvider: authProvider,
    });

    // Get the user from Graph (GET /me)
    const graphUser: MicrosoftGraph.User = await this.graphClient
      .api('/me')
      .select('displayName,mail,mailboxSettings,userPrincipalName')
      .get();

    const user = new User();
    user.displayName = graphUser.displayName ?? '';
    // Prefer the mail property, but fall back to userPrincipalName
    user.email = graphUser.mail ?? graphUser.userPrincipalName ?? '';
    user.timeZone =
      graphUser.mailboxSettings?.timeZone ?? 'Romance Standard Time';

    // Use default avatar
    user.avatar = '/assets/no-profile-photo.png';

    return user;
  }

  async getFilesFromOneDrive(): Promise<any> {
    try {
      if (this.graphClient) {
        const files = await this.graphClient.api('/me/drive/root/children').get();
        return files;
      }
      return [];
    } catch (error) {
      console.error(
        'Erreur lors de la récupération des fichiers OneDrive',
        error
      );
      throw error;
    }
  }
  /*
    async getFilesEntrepriseFromOneDrive(idsite): Promise<any> {
      try {
       
        const files = await this.graphClient.api(`/sites/${idsite}/drive/search(q='AFS - IT')`).get();
        return files;
      } catch (error) {
        console.error('Erreur lors de la récupération des fichiers OneDrive', error);
        throw error;
      }
    }
    */

  async getFilesByFolderName(folderName: string, siteId: string): Promise<any> {
    try {
      // Recherchez le dossier par son nom
      const searchResponse = await this.graphClient
        .api(`/sites/${siteId}/drive/root/search(q='${folderName}')`)
        .get();

      // Trouvez l'ID du dossier
      const folder = searchResponse.value.find(
        item => item.name === folderName && item.folder
      );
      if (!folder) {
        throw new Error(`Dossier ${folderName} introuvable`);
      }

      // Utilisez l'ID du dossier pour récupérer son contenu
      const filesResponse = await this.graphClient
        .api(`/sites/${siteId}/drive/items/${folder.id}/children`)
        .get();
      return filesResponse;
    } catch (error) {
      console.error(
        'Erreur lors de la récupération des fichiers Sharepoint',
        error
      );
      throw error;
    }
  }

  /*async uploadDocument(filename, fileToUpload){
    const uploadURL = "https://graph.microsoft.com/v1.0/sites/<YOUR DOMAIN, SITE, AND WEB ID HERE >/drive/root:/" + filename + ":/content";
      await window
      .fetch(uploadURL, {
        method: "PUT",
        headers: {
          Authorization: `Bearer ${await getMsalToken()}`,
        },
        body: fileToUpload,
      })
      .then((response) => {
          // Here you can implement some user feedback. "File uploaded" etc.. 
      })
      .catch((error) => {
        console.error("ERROR UPLOADING");
        console.error(error);
      });
  }*/

  async uploadFileToFolder(idsite: string, file: File, folderId: any) {
    // Utilisez l'API Microsoft Graph pour télécharger le fichier dans le dossier spécifié
    // Vous pouvez utiliser this.graphClient pour faire cela

    try {
      //const path = `/sites/${idsite}/drive/items/${folderId}/children/${file.name}/content`;

      const path = `/sites/${idsite}/drive/items/${folderId}:/${file.name}:/content`;
      if (this.graphClient) {

        const response = await this.graphClient.api(path).put(file);
        return response;
      }
      return [];
    } catch (error) {
      console.error(
        'Erreur lors du téléchargement des fichiers sur Sharepoint',
        error
      );
      throw error;
    }

    // Gérer la réponse
  }

  async getFileContent(idsite: string, itemId: string) {
    try {
      const path = `/sites/${idsite}/drive/items/${itemId}/content`;
      //const path = `/sites/${idsite}/drive/items/${folderId}/children/${file.name}/content`;
      if (this.graphClient) {
        const response = await this.graphClient.api(path).get();
        return response;
      }
      return [];
    } catch (error) {
      console.error(
        'Erreur lors du téléchargement des fichiers sur Sharepoint',
        error
      );
      throw error;
    }

    // Gérer la réponse
  }

  async downloadFile(idsite: any, itemId: any, fileName: string) {
    try {
      //const path = `/sites/${idsite}/drive/items/${itemId}/content`;
      const path = `/sites/${idsite}/drive/items/${itemId}?select=id,@microsoft.graph.downloadUrl`;
      if (this.graphClient) {
        const response = await this.graphClient.api(path).get();
        const downloadUrl = response['@microsoft.graph.downloadUrl'];
        this.http.get(downloadUrl, { responseType: 'blob' }).subscribe(data => {
          const myblob = new Blob([data], {
            type: 'text/plain',
          });
          const objectUrl = window.URL.createObjectURL(myblob);
          const a: HTMLAnchorElement = document.createElement(
            'a'
          ) as HTMLAnchorElement;

          a.href = objectUrl;
          a.download = fileName;
          document.body.appendChild(a);
          a.click();

          document.body.removeChild(a);
          URL.revokeObjectURL(objectUrl);
        });
      }
      return [];
    } catch (error) {
      console.error(
        'Erreur lors du téléchargement des fichiers sur Sharepoint',
        error
      );
      throw error;
    }

    // Gérer la réponse
  }

  async getFilesEntrepriseFromOneDrive(idsite, path?: string): Promise<any> {
    try {
      let apiPath = `/sites/${idsite}/drive/root/children`;
      if (path) {
        apiPath = path;
      }
      const files = await this.graphClient.api(apiPath).get();
      return files;
    } catch (error) {
      console.error(
        'Erreur lors de la récupération des fichiers OneDrive',
        error
      );
      throw error;
    }
  }

  async getListeSite(): Promise<any> {
    try {
      if (this.graphClient) {
        const files = await this.graphClient.api(`/sites`).get();
        return files;
      }
      return [];
    } catch (error) {
      console.error(
        'Erreur lors de la récupération des liste de site OneDrive',
        error
      );
      throw error;
    }
  }

  // Dans votre service OfficeoauthService

  async deleteFolderOrFile(idsite: string, itemId: any): Promise<void> {
    const endpoint = `/sites/${idsite}/drive/items/${itemId}`;

    try {
      if (this.graphClient) {
        await this.graphClient.api(endpoint).delete();
      }
      // La suppression a réussi
    } catch (error) {
      console.error('Erreur lors de la suppression du dossier/fichier', error);
      throw error; // Propager l'erreur pour la gérer dans le composant
    }
  }

  // Dans votre fichier OfficeoauthService.ts

  async renameFolderOrFile(
    idsite: string,
    itemId: any,
    newName: any
  ): Promise<void> {
    const endpoint = `/sites/${idsite}/drive/items/${itemId}`;

    const updateData = {
      name: newName,
      '@microsoft.graph.conflictBehavior': 'rename',
    };

    try {
      if (this.graphClient) {
        const response = await this.graphClient.api(endpoint).patch(updateData);
      }
      // Pas besoin de retourner quelque chose à moins que vous ne vouliez le nouveau nom ou un autre détail
    } catch (error) {
      console.error('Erreur lors du renommage', error);
      throw error;
    }
  }

  // Dans votre fichier OfficeoauthService.ts
  async createFolderInSharePoint(
    idsite: string,
    folderName: string,
    parentId: any = null
  ): Promise<{ id: string }> {
    let endpoint = `/sites/${idsite}/drive/root/children`;
    if (parentId) {
      endpoint = `/sites/${idsite}/drive/items/${parentId}/children`;
    }

    const folderData = {
      name: folderName,
      folder: {},
      '@microsoft.graph.conflictBehavior': 'rename',
    };

    try {
      if (this.graphClient) {
        const response = await this.graphClient.api(endpoint).post(folderData);
        return { id: response.id }; // Assurez-vous de retourner l'ID ici
      }
      return { id: '' };
    } catch (error) {
      console.error('Erreur lors de la création du dossier', error);
      throw error;
    }
  }

  async folderExists(
    folderName: string,
    parentId: string,
    siteId: string
  ): Promise<boolean> {
    try {
      // Recherchez les sous-dossiers du dossier parent par leur nom
      const searchResponse = await this.graphClient
        .api(`/sites/${siteId}/drive/items/${parentId}/children`)
        .filter(`name eq '${folderName}' and folder ne null`)
        .get();

      // Vérifiez si le dossier recherché existe en vérifiant la longueur du tableau de résultats
      const folderExists = searchResponse.value.length > 0;

      return folderExists;
    } catch (error) {
      console.error(
        "Erreur lors de la vérification de l'existence du dossier",
        error
      );
      throw error;
    }
  }

  async getFolderIdByPath(path: string, idsite: string): Promise<string> {
    try {
      // Divisez le chemin en segments
      const segments = path.split('/').filter(segment => segment.trim() !== '');

      // Commencez par le dossier racine
      let currentFolderId = 'root';
      if (this.graphClient) {
        // Parcourez chaque segment pour obtenir l'ID du dossier correspondant
        for (const segment of segments) {
          const endpoint = `/sites/${idsite}/drive/items/${currentFolderId}/children?$filter=name eq '${segment}'`;

          const response = await this.graphClient.api(endpoint).get();
          if (response && response?.value.length > 0) {
            // Utilisez le premier élément correspondant (devrait être unique)
            currentFolderId = response.value[0].id;
          } else {
            // Le dossier n'existe pas
            throw new Error(`Folder not found: ${segment}`);
          }
        }

      }

      return currentFolderId;
    } catch (error) {
      console.error('Error getting folder ID by path:', error);
      throw error;
    }
  }

  async getFolderIdInRootByPath(
    folderName: string,
    idsite: string,
    currentFolderId: string
  ): Promise<any> {
    try {
      const name = folderName.replace(/[^a-zA-Z0-9]/g, '_');
      const endpoint = `/sites/${idsite}/drive/items/${currentFolderId}/children?$filter=name eq '${name}'`;
      if (this.graphClient) {
        const response = await this.graphClient.api(endpoint).get();

        let folderId = false;
        if (response && response.value.length > 0) {
          folderId = response.value[0].id;
        }
        return folderId;
      }
      return false;
    } catch (error) {
      //console.error('Error getting folder ID by path:', error);
      //throw error;
      return false;
    }
  }

  async getFoldersByPath(endpoint: string): Promise<any> {
    try {
      if (this.graphClient) {
        const response = await this.graphClient.api(endpoint).get();

        let folderId = false;
        if (response && response.value.length > 0) {
          return response.value;
        }
      }
      return false;
    } catch (error) {
      //console.error('Error getting folder ID by path:', error);
      //throw error;
      return false;
    }
  }

  async copyFolderContent(
    sourceFolderId: string,
    sourceSiteId: string,
    destinationFolderId: string,
    destinationSiteId: string
  ): Promise<void> {
    try {
      // Obtenir les éléments du dossier source
      const sourceItems = await this.graphClient
        .api(`/sites/${sourceSiteId}/drive/items/${sourceFolderId}/children`)
        .get();

      // Parcourir chaque élément du dossier source
      for (const item of sourceItems.value) {
        if (item.folder) {
          // Si l'élément est un dossier, créer un dossier correspondant dans le dossier cible
          const newFolder = await this.createFolderInSharePoint(
            destinationSiteId,
            item.name,
            destinationFolderId
          );

          // Appeler récursivement pour copier le contenu du sous-dossier
          await this.copyFolderContent(
            item.id,
            sourceSiteId,
            newFolder.id,
            destinationSiteId
          );
        } else {
          // Si l'élément est un fichier, copier le fichier dans le dossier cible
          const fileContent = await this.graphClient
            .api(`/sites/${sourceSiteId}/drive/items/${item.id}/content`)
            .get();

          await this.uploadFileToFolder(
            destinationSiteId,
            new File([fileContent], item.name),
            destinationFolderId
          );
        }
      }
    } catch (error) {
      console.error('Erreur lors de la copie du contenu du dossier', error);
      throw error;
    }
  }

  async getFilesFromSharedDrive(rootPath: any = 'prospect') {
    if (!this.graphClient) {
      await this.initializeGraphClient();
    }
    const idsiteDeal =
      'aetherfs.sharepoint.com,1eaf938d-e8b2-4d23-bb14-06f0b5ce5755,255e87e3-7311-4789-816a-c6974dadc942';
    const idSiteProspect =
      'aetherfs.sharepoint.com,455cb06a-c9e3-4cd3-84f0-d964f19456a8,255e87e3-7311-4789-816a-c6974dadc942';
    const idRootSite = rootPath === 'prospect' ? idSiteProspect : idsiteDeal;
    const pathProspect = '03. Meeting and Call for Tenders';
    const pathDeal = '05. List of Mandates';
    const pathRoot = rootPath === 'prospect' ? pathProspect : pathDeal;

    if (this.graphClient) {
      const drive = await this.graphClient
        .api(`/sites/${idRootSite}/drives`)
        .get();

      const driveId = drive.value[0]?.id;

      const files = await this.getAllFilesFromApi(`/drives/${driveId}/root/children`);

      const mandates = files?.find((item: any) => item.name === pathRoot);
      const mandatesFiles = await this.getAllFilesFromApi(`/sites/${idRootSite}/drive/items/${mandates.id}/children`);
      if (this.rootPath === 'prospect') {
        const currentYear = new Date().getFullYear();
        const mandates = mandatesFiles?.find(
          (item: any) => item.name === currentYear.toString()
        );
        const mandatesChildren = await this.getAllFilesFromApi(`/sites/${idSiteProspect}/drive/items/${mandates.id}/children`);
        return mandatesChildren;
      }
      return mandatesFiles;
    }

    throw new Error('Graph client is not initialized or no files found');
  }

  async getAllFiles(url: string): Promise<any[]> {
    let allFiles: any[] = [];
    while (url) {
      const response = await this.graphClient
        .api(url.replace('https://graph.microsoft.com/v1.0', ''))
        .get();
      allFiles = allFiles.concat(response.value);
      url = response['@odata.nextLink'] || null;
    }
    return allFiles;
  }

  async getAllFilesFromApi(apiPath: string): Promise<any[]> {
    if (!this.graphClient) {
      await this.initializeGraphClient();
    }
    let allFiles: any[] = [];
    let url: string | null = apiPath;

    while (url) {
      const response = await this.graphClient.api(url).get();
      allFiles = allFiles.concat(response.value || []);
      url = response['@odata.nextLink']
        ? response['@odata.nextLink'].replace('https://graph.microsoft.com/v1.0', '')
        : null;
    }
    return allFiles;
  }

  async openFolder(folder: any, rootPath: any = 'prospect') {
    const idsiteDeal =
      'aetherfs.sharepoint.com,1eaf938d-e8b2-4d23-bb14-06f0b5ce5755,255e87e3-7311-4789-816a-c6974dadc942';
    const idSiteProspect =
      'aetherfs.sharepoint.com,455cb06a-c9e3-4cd3-84f0-d964f19456a8,255e87e3-7311-4789-816a-c6974dadc942';
    const idRootSite = rootPath === 'prospect' ? idSiteProspect : idsiteDeal;

    if (this.graphClient) {
      if (folder.id) {
        try {
          const files = await this.getAllFilesFromApi(`/sites/${idRootSite}/drive/items/${folder.id}/children`);
          return files;
        } catch (err) {
          console.error('Erreur lors de l\'ouverture du dossier :', err);
          return [];
        }
      } else {
        return [];
      }
    }
    throw new Error('Graph client is not initialized or no files found');
  }

  async getFolderById(driveId: string, folderId: string) {
    if (this.graphClient) {
      const files = await this.getAllFilesFromApi(`/drives/${driveId}/items/${folderId}/children`);
      return files;
    }
    throw new Error('Graph client is not initialized or no files found');
  }

  async goToParentFolder(parentId: string, driveId: string) {
    if (this.graphClient) {
      try {
        const children = await this.getAllFilesFromApi(`/drives/${driveId}/items/${parentId}/children`);
        return children;
      } catch (error) {
        console.error('Error navigating to parent folder:', error);
        throw error;
      }
    }
    throw new Error('Graph client is not initialized or no files found');
  }

  async getParentFolder(driveId: string, currentFolderId: string) {
    if (this.graphClient) {
      const currentFolder = await this.graphClient
        .api(`/drives/${driveId}/items/${currentFolderId}`)
        .get();

      const parentReference = currentFolder?.parentReference;

      if (parentReference?.id) {
        const parentChildren = await this.getAllFilesFromApi(`/drives/${driveId}/items/${parentReference.id}/children`);

        return {
          files: parentChildren,
          parentId: parentReference.id,
          driveId: parentReference.driveId,
        };
      } else {
        const rootChildren = await this.getAllFilesFromApi(`/drives/${driveId}/root/children`);
        return {
          files: rootChildren,
          parentId: null,
          driveId: driveId,
        };
      }
    }

    throw new Error('Graph client not initialized');
  }
}
